import { useTheme } from '../context/ThemeContext'
import './ThemeToggle.css'

export default function ThemeToggle() {
  const { theme, toggleTheme } = useTheme()
  const isLight = theme === 'light'
  return (
    <>
      <button
        type="button"
        className="theme-toggle"
        onClick={toggleTheme}
        aria-label={`Switch to ${isLight ? 'dark' : 'light'} theme`}
        aria-pressed={isLight}
        title={`Switch to ${isLight ? 'dark' : 'light'} theme`}
      >
        <span className="theme-toggle-track">
          <span className="theme-toggle-icon sun" aria-hidden="true">☀</span>
          <span className="theme-toggle-icon moon" aria-hidden="true">☾</span>
          <span className={`theme-toggle-thumb ${isLight ? 'right' : 'left'}`} />
        </span>
      </button>
    </>
  )
}
